import { injectable } from "tsyringe";
import { ISimLookupRepository } from "../repositories/ISimLookupRepository";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { SimLookupInjection } from "features/simStatusLookup/di/SimLookupInjection";
import { SimLookupRequestEntity } from "../entities/SimLookupRequestEntity";
import { SimLookupResponseEntity } from "../entities/SimLookupResponseEntity";

@injectable()
export class SimLookupUseCase {
  private simLookupRepo: ISimLookupRepository;

  constructor() {
    this.simLookupRepo = SimLookupInjection.getRepo();
  }

  async getSimLookup(
    params: SimLookupRequestEntity,
  ): Promise<BaseApiResponseModel<SimLookupResponseEntity>> {
    return await this.simLookupRepo.getSimLookup(
      new SimLookupRequestEntity({ iccid: params.iccid?.trim() }),
    );
  }
}
